import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from 'src/components/editor/EditTracking';

const RatingAnswerSurveyTracking_0301: FC = () => {
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      background: none;

      .close {
        width: 100%;
      }

      .center_wrapper {
        width: 100%;
      }

      .textarea {
        padding: 0;
        background: transparent;
      }

      .bottom button {
        background: none;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view root_view_0301 root_tracking">
        <div className="template">
          <div className="center_horizon close tracking_center">
            <EditTracking
              value={tracking?.close_0301?.[currentIndex]}
              type="close_0301"
            />
          </div>
          <div className="center_wrapper">
            <div className="logo" />
            <div className="title" />
            <div className="sub_title" />
            <div className="star_wrapper" />
            <div className="textarea tracking_center">
              <EditTracking
                value={tracking?.text_area_0301?.[currentIndex]}
                type="text_area_0301"
              />
            </div>
          </div>
          <div className="center_horizon bottom">
            <button className="button tracking_center">
              <EditTracking
                value={tracking?.button_0301?.[currentIndex]}
                type="button_0301"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingAnswerSurveyTracking_0301;
